import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    jobRoleRequestList: {
        requesting: false,
        items: [],
        pagination: {
            current_page: 1,
            per_page: 10,
            total: 0,
        },
        error: null,
        success: false,
        filters: {},
    },
    jobRoleRequestDetails: {
        requesting: false,
        error: null,
        success: false,
        data: null
    },
  };

export const jobRoleRequestSlice = createSlice({
  name: 'jobRoleRequest',
  initialState,
  reducers: {
    getJobRoleRequestList: (state, action) => {
        state.jobRoleRequestList.requesting = true;
        state.jobRoleRequestList.error = null;
        state.jobRoleRequestList.items = [];
        state.jobRoleRequestList.success = false;
        state.jobRoleRequestList.filters = action.payload;
    },
    getJobRoleRequestListSuccess: (state, action) => {
		const { data, current_page, per_page, total} = action.payload;
        state.jobRoleRequestList.requesting = false;        
        state.jobRoleRequestList.items = data;
        state.jobRoleRequestList.success = true; 
        state.jobRoleRequestList.pagination.current_page = current_page;
        state.jobRoleRequestList.pagination.per_page = per_page;
        state.jobRoleRequestList.pagination.total = total;
    },
    getJobRoleRequestListFail: (state, action) => {        
        state.jobRoleRequestList.requesting = false;
        state.jobRoleRequestList.error = action.payload;
    },
    getJobRoleRequestDetails: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
    getJobRoleRequestDetailsSuccess: (state, action) => {
        state.jobRoleRequestDetails.requesting = false;
        state.jobRoleRequestDetails.data = action.payload;
        state.jobRoleRequestDetails.success = true; 
    },
    getJobRoleRequestDetailsFail: (state, action) => {        
        state.jobRoleRequestDetails.requesting = false;
        state.jobRoleRequestDetails.error = action.payload;
    },
    doJobRoleRequestCreate: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
    doJobRoleRequestUpdate: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
    doJobRoleRequestDelete: (state) => {
        state.jobRoleRequestDetails.requesting = true;
        state.jobRoleRequestDetails.error = null;
        state.jobRoleRequestDetails.data = null;
        state.jobRoleRequestDetails.success = false; 
    },
  },
})

export const { 
    getJobRoleRequestList, getJobRoleRequestListSuccess, getJobRoleRequestListFail,
    getJobRoleRequestDetails, getJobRoleRequestDetailsSuccess, getJobRoleRequestDetailsFail,
    doJobRoleRequestCreate, doJobRoleRequestUpdate, doJobRoleRequestDelete,
} = jobRoleRequestSlice.actions

export default jobRoleRequestSlice.reducer